import type * as lazyIndex from './lazyIndex';
export { default as loadTableViewFromTableQuery } from './actions/loadTableViewFromTableQuery';
export { setTableViewErrorStateMutator } from './actions/onInitialTableLoadComplete';
export { default as onInitialTableLoadComplete } from './actions/onInitialTableLoadComplete';
import './orchestrators/loadTableViewFromSearchTableQueryOrchestrator';
import './orchestrators/loadMessageSuggestionIntoTableOrchestrator';
import './orchestrators/selectFocusedViewFilterOrchestrator';
import './orchestrators/initializeLazyImports';
import { onListViewTypeOptionSaved } from 'owa-options-actions/lib/onListViewTypeOptionSaved';

import { LazyModule, LazyAction, registerLazyOrchestrator } from 'owa-bundling';
const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(
    () => import(/* webpackChunkName:"TableLoading" */ './lazyIndex'),
    { name: 'mail/packages/mail/orchestration/owa-mail-table-loading-actions' }
);

registerLazyOrchestrator(
    onListViewTypeOptionSaved,
    lazyModule,
    m => m.onListViewTypeOptionSavedOrchestrator
);

export const lazyLoadCopilotCatchUpFilter: LazyAction<
    typeof lazyIndex.loadCopilotCatchUpFilter,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadCopilotCatchUpFilter);

export const lazyLoadCopilotHeadlinesFilter: LazyAction<
    typeof lazyIndex.loadCopilotHeadlinesFilter,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.loadCopilotHeadlinesFilter);

export const lazyDismissCopilotResultsTable: LazyAction<
    typeof lazyIndex.dismissCopilotResultsTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.dismissCopilotResultsTable);

export const lazySwitchToCopilotResultsTable: LazyAction<
    typeof lazyIndex.switchToCopilotResultsTable,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.switchToCopilotResultsTable);
